/*! @azure/msal-react v2.2.0 2024-11-05 */
'use strict';
import { useContext } from 'react';
import { MsalContext } from '../MsalContext.js';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Returns Msal Context values
 */
const useMsal = () => useContext(MsalContext);

export { useMsal };
//# sourceMappingURL=useMsal.js.map
